<style lang="less" scoped>
  .margin-left-15 {
    margin-left: 15px;
  }
  .detail-form-parent-child-div {
    margin-top: 10px;
    align-items: center;
  }
  .detail-form-parent-title-div {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
      Microsoft YaHei, SimSun, sans-serif;
    width: 120px;
  }
  .detail-history ::v-deep el-dialog__body{
    padding: 48px;
    box-sizing: border-box;
  }
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="产商标识">
                <div>{{ detailForm.manufactorId }}</div>
              </el-form-item>
              <el-form-item label="充电桩编号">
                <div>{{ detailForm.pileNo }}</div>
              </el-form-item>
              <el-form-item label="是否有蓝牙" >
                <el-select class="full-width" v-model="detailForm.isBluetooth"  disabled clearable @change="hadlePileTypeChange($event)">
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="最新版本号">
                <el-input  v-model="detailForm.versionId" disabled  size="small"></el-input>
              </el-form-item>
              <el-form-item label="升级状态" >
                <el-input  v-model="detailForm.upgradeStatus" disabled  size="small"></el-input>
              </el-form-item>
              <el-form-item style="white-space: nowrap;" label="最新版本下载路径" >
                <el-input v-model="detailForm.versionDownloadPath" disabled></el-input>
              </el-form-item>
              <el-form-item label="最新版本描述" >
                <el-input type="textarea" v-model="detailForm.versionDesc" disabled  size="small"></el-input>
              </el-form-item>
              <el-form-item label="升级开始时间" >
                <el-input prefix-icon="el-icon-date" v-model="detailForm.upgradeStartTime"  style="width: 80%;" size="small" disabled></el-input>
              </el-form-item>
              <el-form-item label="升级失败原因">
                <el-input type="textarea" v-model="detailForm.upgradeFailReason" size="small"></el-input>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item label="充电桩型号名称">
                <div>{{detailForm.pileTypeName}}</div>
              </el-form-item>
              <el-form-item label="所属用户">
                <div>{{ detailForm.custPhone }}</div>
              </el-form-item>
              <el-form-item label="当前版本号" >
                <el-select class="full-width" v-model="detailForm.currentVersionNo"  size="small" disabled clearable filterable>
                  <el-option v-for="item in versionNo" :label="item" :value="item" :key="item"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="新版本下发时间" >
                <el-input  v-model="detailForm.checkedTime"  style="width: 80%;" size="small" disabled></el-input>
                <!-- <el-select class="full-width" disabled size="small" clearable>
                  <el-option v-for="item in optTypes" :label="item.configName" :value="item.configVal"
                    :key="item.id" @click.native="handleOptChange(item)"></el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item label="升级方式" >
                <el-input  v-model="detailForm.upgradeMethod"  style="width: 80%;" size="small" disabled></el-input>
                <!-- <el-select class="full-width"  disabled size="small" >
                  <el-option v-for="item in chargingSpeeds" :label="item.configName" :value="item.configVal" :key="item.id"></el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item label="升级结束时间">
                <el-input prefix-icon="el-icon-date" v-model="detailForm.upgradeEndTime"  style="width: 80%;" size="small" disabled></el-input>
                
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
    <!--  历史记录  -->
    <div class="detail-history">
      <el-dialog :visible.sync="dialogFormVisible" width="32%" :modal="false" top="24vh">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities" :key="index">
            开始时间：{{activity.startTime}} 结束时间：{{ activity.endTime }}
          </el-timeline-item>
        </el-timeline>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig,
      editFlag: true,
      pageTitle: '升级管理编辑', //页面标题 // 默认值设置
      detailForm: {}, //  默认表单值
      pileChargeEntity: {}, // 查询编辑表单内容
      dealers: [], //	所有经销商下拉框
      pileTypes: [], //	所有充电商下拉框
      chargingSpeeds: [], //	充电速度下拉框
      optTypes: [], //	桩类型下拉框下拉框
      currentOuts: [], //	电流输出类型下拉框
      interfaces: [], //	接口标准下拉框
      allChargeSelectData: [], //资费名称下拉框

      warranty: '',   // 质保有效期
      subscribe: '',  // 联网订阅有限期
      dialogFormVisible: false,   // 历史记录
      activities: [],
      versionNo:[],
      // 尖峰平谷
      leftPileValleyTime: [],
      rightPileValleyTime: [],

    }
  },
  methods: {
    getVersionNo(){
      let _ = this;
      _.$H.post(_, _.$A.custVersion.version,{}).then((res) => {
        console.log(res);
       _.versionNo = res.data.data.map((item)=>{
        return item.versionNo
       })
       console.log(_.versionNo);
      });
      
    },
      //判断是否为编辑模式
    init() {
      if (localStorage.getItem('upgradeDetail')) {
        this.pageTitle = '升级管理编辑'
        this.editFlag = true;
        // console.log(this.$route.params.selections);
        
        this.detailForm = JSON.parse(localStorage.getItem('upgradeDetail'));
        console.log(this.detailForm);
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.$H.post(_, _.$A.digitization.pileInfo, { pileCode: _.$store.state.editId }).then((res) => {

        _.detailForm = res.data.data;
        debugger

        if(res.data.data.pileBindTimeEntity){
          _.detailForm.warrantyEndTime = res.data.data.pileBindTimeEntity.warrantyEndTime
          _.detailForm.networkEndTime = res.data.data.pileBindTimeEntity.networkEndTime
        }

        // 尖峰平谷
        if(res.data.data.pileValleyTimeEntityList.length !== 0){
          _.detailForm.pileValleyTimeEntityList.forEach(li => {
            li.time = li.startTime + ' ~ ' + li.endTime;
          })
          _.leftPileValleyTime = _.detailForm.pileValleyTimeEntityList.filter((item, index) => index % 2 === 0)
          _.rightPileValleyTime = _.detailForm.pileValleyTimeEntityList.filter((item, index) => index % 2 !== 0)
        }
        //质保时间
        if(res.data.data.warrantyTimeEntity.length !== 0){
          let arrWar = res.data.data.warrantyTimeEntity
          _.warranty = arrWar[0].startTime + arrWar[arrWar.length - 1].endTime;
        }
        //联网时间
        if(res.data.data.networkTimeEntity.length !== 0){
          let arrNet = res.data.data.networkTimeEntity
          _.subscribe = arrNet[0].startTime + arrNet[arrNet.length - 1].endTime;
        }
      })
    },
    //获取所有下拉框列表
    getConfig() {
      let _ = this
      //经销商
      _.$H.post(_, _.$A.pile.dealer, {}).then((res) => {
        _.dealers = res.data.data
      })
      //桩型号
      _.$H.post(_, _.$A.pile.type, {}).then((res) => {
        _.pileTypes = res.data.data
      })
      //充电速度
      _.$H.post(_, _.$A.config.list, { configType: '101' }).then((res) => {
        _.chargingSpeeds = res.data.data
      })
      //桩类型
      _.$H.post(_, _.$A.config.list, { configType: '105' }).then((res) => {
        _.optTypes = res.data.data
      })
      //电流输出类型
      _.$H.post(_, _.$A.config.list, { configType: '100' }).then((res) => {
        _.currentOuts = res.data.data
      })
      //接口标准
      _.$H.post(_, _.$A.config.list, { configType: '102' }).then((res) => {
        _.interfaces = res.data.data
      })
      //资费名称
      _.$H.post(_, _.$A.pile.pileCharge, {useState: '01', corpNo: _.$store.state.corpNo,}).then((res) => {
          _.allChargeSelectData = res.data.data
          _.allChargeSelectData.forEach((item) => {
            item.value = item.chargeName
          })
        })
    },
    //选择经销商
    handleDealChange(val) {
      this.detailForm.dealNo = val.dealNo
      this.detailForm.dealName = val.dealName
    },
    //选择充电桩型号名称
    hadlePileTypeChange(val) {
      let _ = this;
      _.pileTypes.forEach(li => {
        if(li.pileTypeNo === val){
          _.detailForm.gunNum = li.gunNum;
          _.detailForm.currentOutType = li.currentOutType;
          _.detailForm.chargingSpeed = li.chargingSpeed;
          _.detailForm.interfaceType = li.interfaceType;
        }
      })
    },
    //选择充电桩型号
    handleOptChange(val) {
      this.detailForm.optType = val.configVal
      this.detailForm.optTypeName = val.configName
    },
    // 表单提交
    submitForm(formName) {
      let _ = this
      _.detailForm.corpNo = _.$store.state.corpNo;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$U.showLoading(_);
          
          _.$H.post(_, _.$A.upgradeManager.edit, _.detailForm).then(res => {
            _.$U.hideLoading(_)
            _.$U.success('修改成功！');
            _.$router.push({name: pageConfig.UpgradeManagement})
          })
        }
      })
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.UpgradeManagement,
      })
    },
    // 历史记录
    handleHistroy(row){
      let _ = this;
      if(row.length !== 0){
        _.activities = row
        _.dialogFormVisible = true;
      }else{
        _.$U.error('暂无数据！')
      }
    },

  },
  mounted() {
    this.init()
  },
}
</script>
